// app/router.tsx
import { createRouter as createTanStackRouter } from "@tanstack/react-router";
import { routeTree } from "./routeTree.gen";
import { QueryClient } from "@tanstack/react-query";
import { routerWithQueryClient } from "@tanstack/react-router-with-query";

export function createRouter() {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 1000 * 60 * 5, // 5 minutes
      },
    },
  });

  return routerWithQueryClient(
    createTanStackRouter({
      defaultNotFoundComponent: () => {
        return (
          <div className="bg-linear-to-r from-slate-200 to-gray-200 dark:from-gray-800 dark:to-gray-900 text-black dark:text-white">
            <div className="flex items-center justify-center min-h-screen px-2">
              <div className="text-center">
                <h1 className="text-7xl font-light">404</h1>
                <p className="mt-4 mb-8">The page you're looking for doesn't exist or has been moved.</p>
                <a
                  href="/"
                  className="px-4 py-2 text-sm bg-background opacity-70 font-semibold rounded-full transition duration-150 ease-in-out dark:bg-gray-700 dark:text-white hover:shadow hover:opacity-100"
                >
                  Go Back Home
                </a>
              </div>
            </div>
          </div>
        );
      },
      routeTree,
      scrollRestoration: true,
      context: {
        queryClient,
      },
    }),
    queryClient
  );
}

export function getRouter() {
  return createRouter();
}

declare module "@tanstack/react-router" {
  interface Register {
    router: ReturnType<typeof createRouter>;
  }
}
